import { Component, OnInit, Input, Injector } from '@angular/core';
import { BaseService } from '../../../base/shared/services/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterService } from 'src/modules/base/services/filter.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { PrintService } from 'src/modules/base/shared/services/print.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { FormService } from 'src/modules/base/components/form/form.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { Location } from '@angular/common';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
@Component({
    selector: 'app-track-order',
    templateUrl: './track-order.component.html',
    styleUrls: ['./track-order.component.scss'],
    standalone: false
})
export class TrackOrderComponent implements OnInit {
  @Input() input: string;
  @Input() filters: string;
  public _currentData: any = {};
  data: any;
  keys: any;
  page: any = 0;
  limit: any = 10;
  GridData: any;
  sortData: any;
  applyFilter: boolean = false;
  filterValue: any;
  dataGridConfig: any = {
    "viewAll": true,
    "hideSearchBox": false,
    "hideResult": false,
    "customButtonsAllowed": false,
    "allowPagination": true,
    "noCount": false,
    "save_filter": true,
    "hideUgfilter": true,
    "allowConfigGrid": true,
    "activeField": 'table',
    "tile": false,
    "table":true,
    "hideSaveAs": true,
  }

  constructor(
    private baseService: BaseService,
    public route: Router,
    private filterService: FilterService,
    private loader: LoaderService,
    public utilService: UtilService,
    private printService?: PrintService,
    private formService?: FormService,
    private aRoute?: ActivatedRoute,
    private storageService?: StorageService,
    public locationCommon?: Location,
    public rolePermissionService?: RolePermissionService,
    public appService?: AppService,
    public preferenceService?: PreferenceService,
    public injector?: Injector,
  ) { }

  ngOnInit() {
    if (this.aRoute.snapshot.queryParams["p__no"] != undefined) {
      this.dataGridConfig.page_no = parseInt(this.aRoute.snapshot.queryParams["p__no"]);
      this.page = parseInt(this.aRoute.snapshot.queryParams["p__no"]);
    }
    if (this.aRoute.snapshot.queryParams["p__size"] != undefined) {
      this.dataGridConfig.limit = parseInt(this.aRoute.snapshot.queryParams["p__size"]);
      this.limit = parseInt(this.aRoute.snapshot.queryParams["p__size"]);
    }
    if (this.input) {
      this.getCurrentResource(this.input);
    }
    this.baseService.setTitle("Track Order");
  }
  
  hasFilterBlocks(): boolean {
    return !!(this._currentData?.resouceDef?.list?.filter?.blocks?.length);
  }

  //get current resource
  getCurrentResource(resource) {
    this.baseService.getResourceDef(resource, (resouceDef) => {
      if (resouceDef) {
        var key = this.preferenceService.getConfigurationKey(this.input);
        this.preferenceService.getUserPreferenceConfig(key, (data) => {
          if (data) {
            this['configGridActions'] = data;
          }
          this.preferenceService.applyJsonConfig({ layout: this, resouceDef: resouceDef }, this['configGridActions']);
        });
        
        if (resouceDef.list != undefined && resouceDef.list.APIresource != undefined && resouceDef.list.APIresource.datasource != undefined) {
          this._currentData.datasource_cloned = JSON.parse(JSON.stringify(resouceDef.list.APIresource.datasource));
          this.dataGridConfig['filter'] = this._currentData.datasource_cloned;
        }

        this._currentData.resouceDef = resouceDef;
        this._currentData.bulkAction = resouceDef.list?.bulkAction ? resouceDef.list.bulkAction : false;
        this.getKeys();
        this._currentData.blocks = resouceDef; //for filter fields
        this.dataGridConfig.resource = this.input ? this.input : '';
        this.dataGridConfig.complex_search = resouceDef.list.complex_search;
        if (resouceDef.list.APIresource != undefined && resouceDef.list.APIresource.datasource != undefined && resouceDef.list.APIresource.datasource.sortData != undefined) {
          this.sortData = resouceDef.list.APIresource.datasource.sortData;
        }
        if (resouceDef.config && resouceDef.config.noCount) {
          this.dataGridConfig['noCount'] = resouceDef.config.noCount
        }
        this.hasData();
      }
    });
  }

  getKeys() {
    let mappingKey = this._currentData.resouceDef.list.GETstations.datasource != undefined && this._currentData.resouceDef.list.GETstations.datasource.mappingKey != undefined ? this._currentData.resouceDef.list.GETstations.datasource.mappingKey : "stage";
    this._currentData.stations_info = this._currentData.resouceDef.list.GETstations.datasource;
    this.baseService.get(this._currentData.stations_info.query_id, this._currentData.stations_info.args, this._currentData.stations_info.resource, this._currentData.stations_info.application, this._currentData.stations_info.filter).subscribe((res) => {
      if (res != undefined && res.errCode == 0 && res.resource != undefined && res.resource) {
        this._currentData.station_resource = res.resource;
        var resource = this._currentData.station_resource.sort(function (a, b) { return a.sequence - b.sequence });
        var arr = [];
        for (let i = 0; i < resource.length; i++) {
          arr.push(resource[i][mappingKey]);
        }
        this.getFinalKeys(arr);
      } else {
        this.formService.alerts.error(res.message);
      }
    })
  }
  getFinalKeys(arr: any) {
    let mappingKey = this._currentData.resouceDef.list.GETstations.datasource != undefined && this._currentData.resouceDef.list.GETstations.datasource.mappingKey != undefined ? this._currentData.resouceDef.list.GETstations.datasource.mappingKey : "stage";
    let mappingVal = this._currentData.resouceDef.list.GETstations.datasource != undefined && this._currentData.resouceDef.list.GETstations.datasource.mappingVal != undefined ? this._currentData.resouceDef.list.GETstations.datasource.mappingVal : "display";
    this.keys = [];
    for (let i = 0; i < arr.length; i++) {
      var makeKeys = {};
      makeKeys['heading'] = this._currentData.station_resource.find(x => x[mappingKey] == arr[i]) == undefined ? arr[i] : this._currentData.station_resource.find(x => x[mappingKey] == arr[i])[mappingVal];
      makeKeys["card_tag"] = null;
      makeKeys["order"] = i + 10;
      makeKeys["sortable"] = true;
      makeKeys["type"] = "metro";
      makeKeys["name"] = arr[i];
      this.keys.push(makeKeys)
    }
    
    if (this._currentData.resouceDef && this._currentData.resouceDef.list.gridButtons != undefined) {
      if (this.keys.find(elem => (elem.name == 'gridButton')) == undefined) {
        this._currentData.resouceDef.list.gridButtons.name = "gridButton";
        this.keys.push(this._currentData.resouceDef.list.gridButtons);
      }
    }

    this.keys.push({
      "heading": "field.label.tag",
      "card_tag": null, "type": "array",
      "format": "fn=function(item){var str=''; return str= item['visible']!=undefined && (item['visible']==true ||item['visible']=='true' )? str+item['key_name']+':'+ item['key_value_display']:''}",
      "order": this.keys.length + 1,
      "name": "tag_data"
    })

    let capability = JSON.parse(JSON.stringify(this._currentData.resouceDef.capability));
    // for (let i = 0; i < this._currentData.resouceDef.capability.length; i++) {
    //   let permissionCheck = false;
    //   let capabilityCheck = this._currentData.resouceDef.capability[i];
    //   if (capabilityCheck != undefined && capabilityCheck.permission_required) {
    //     permissionCheck = this.rolePermissionService.checkAccessPermission(capabilityCheck.action_name, capabilityCheck.resource);
    //     if (!permissionCheck) {
    //       capability.pop(i);
    //     }
    //   }
    // }
    capability = capability.filter(cap => {
      if (cap && cap.permission_required) {
        return this.rolePermissionService.checkAccessPermission(cap.action_name, cap.resource);
      }
      return true;
    });
    this._currentData.resouceDef.capability = capability;
    this.keys.push({
      "heading": "",
      "order": this.keys.length + 100,
      "sortable": false,
      "name": "",
      "config": {
        "type": "ellipse",
        "buttonMenu": this._currentData.resouceDef.capability
      }
    })
    // for (let i = 0; i < this._currentData.resouceDef.list.fields.length; i++) {
    this.keys.unshift(...this._currentData.resouceDef.list.fields);
    // }
    this._currentData.finalKeys = this.keys.sort(function (a, b) { return a.order - b.order })
    console.log("keys", this.keys);
    console.log("finalKeys", this._currentData.finalKeys);
  }

  updateCurrentDataFromSavedFilter() {
    try {
      if (this._currentData.loadSavedFilter != undefined) {
        this._currentData.gridData = {};
        var filterSavedObj = this.getFilterLabel();
        if (filterSavedObj && filterSavedObj["filter"] != undefined && !this.dataGridConfig['resetFilter_ts']) {
          // this.dataGridConfig['filter'] = filterSavedObj["filter"];//apply filter which is in url 

          if (this._currentData != undefined && this._currentData.datasource != undefined) {
            this._currentData.datasource.filter = filterSavedObj["filter"];
            this._currentData.resouceDef.list.APIresource.datasource.filter = filterSavedObj["filter"];
          }
          else {
            this._currentData.datasource = {};
            this._currentData.datasource['filter'] = filterSavedObj["filter"];
            this._currentData.resouceDef.list.APIresource.datasource.filter = filterSavedObj["filter"];
          }

        }
        if (this.dataGridConfig['resetFilter_ts'] != undefined && this._currentData.datasource_cloned != undefined && this._currentData.datasource_cloned.filter != undefined) {
          this._currentData.datasource['filter'] = this._currentData.datasource_cloned.filter;
          this.dataGridConfig['filter'] = this._currentData.datasource_cloned.filter;
          this._currentData.resouceDef.list.APIresource.datasource.filter = this.dataGridConfig['filter'];
        }
        if (filterSavedObj && filterSavedObj["filterLabel"] != undefined && !this.dataGridConfig['resetFilter_ts']) {
          this.dataGridConfig["filterLabel"] = filterSavedObj["filterLabel"];//apply filter which is in url
        }

        if (filterSavedObj && filterSavedObj["search_columns"] != undefined && !this.dataGridConfig['resetFilter_ts'] && !this.dataGridConfig['compex_search_ts']) {
          this.dataGridConfig['search_columns'] = filterSavedObj["search_columns"];//apply filter which is in url
          this.dataGridConfig['f__search_columns'] = filterSavedObj["search_columns"];
          this._currentData.searchKey = {};
          this._currentData.searchKey['key'] = filterSavedObj["search_columns"];
        }

        if (filterSavedObj && filterSavedObj["search"] != undefined && !this.dataGridConfig['resetFilter_ts'] && !this.dataGridConfig['compex_search_ts']) {
          this.dataGridConfig['search'] = filterSavedObj["search"];//apply filter which is in url
          this.dataGridConfig['f__search'] = filterSavedObj["search"];

          this._currentData.searchKey['value'] = filterSavedObj["search"];

        }

        if (filterSavedObj && filterSavedObj["searchColumns"] != undefined && !this.dataGridConfig['resetFilter_ts'] && !this.dataGridConfig['compex_search_ts']) {
          this.dataGridConfig['searchColumns'] = filterSavedObj["searchColumns"];//apply filter which is in url
          this.dataGridConfig['f__searchColumns'] = filterSavedObj["searchColumns"];
          this._currentData.searchKey['key'] = filterSavedObj["searchColumns"];

        }
        if (filterSavedObj && filterSavedObj["searchLabel"] != undefined && !this.dataGridConfig['compex_search_ts']) {
          this.dataGridConfig['searchLabel'] = filterSavedObj["searchLabel"];//apply filter which is in url
          this.dataGridConfig['f__searchLabel'] = filterSavedObj["searchLabel"];
        }
        if (filterSavedObj && filterSavedObj["noRule"] != undefined && filterSavedObj["noRule"] != undefined) {
          this.dataGridConfig['noRule'] = filterSavedObj["noRule"];//apply filter which is in url
        }
        //var filterSaveKey = "f__k";
        // delete this._currentData.saveFilterKey;
        if (this.dataGridConfig != undefined && this.dataGridConfig['resetFilter_ts'] != undefined) {
          delete this.dataGridConfig['resetFilter_ts']
        }
        if (this.dataGridConfig != undefined && this.dataGridConfig['compex_search_ts'] != undefined) {
          delete this.dataGridConfig['compex_search_ts']
        }

        if (filterSavedObj && filterSavedObj["eq_search"] != undefined && !this.dataGridConfig['resetFilter_ts'] && !this.dataGridConfig['compex_eq_search_ts']) {
          this.dataGridConfig['eq_search'] = filterSavedObj["eq_search"]; //apply eq_search after redirect back
          this.dataGridConfig['f__eq_search'] = filterSavedObj["eq_search"];
          this._currentData.searchKey['eq_search'] = filterSavedObj["eq_search"];
        }

        if (filterSavedObj && filterSavedObj["filterName"] != undefined && this.dataGridConfig && this.dataGridConfig.filterConfig != undefined && this.dataGridConfig.filterConfig.currentFilter != undefined) {
          this.dataGridConfig.filterConfig["FilterName"] = this.dataGridConfig.filterConfig.FilterName ? this.dataGridConfig.filterConfig.FilterName : filterSavedObj["filterName"];
        } else {
          if (filterSavedObj && filterSavedObj["filterName"] != undefined && this.dataGridConfig && this.dataGridConfig.filterConfig == undefined) {
            this.dataGridConfig.filterConfig = {};
            this.dataGridConfig["filterName"] = filterSavedObj["filterName"];
            this.dataGridConfig.filterConfig["FilterName"] = filterSavedObj["filterName"];
            this.dataGridConfig.filterConfig["filterName"] = filterSavedObj["filterName"];
          }
        }
        if (filterSavedObj && filterSavedObj["filterAr"] != undefined && this.dataGridConfig && this.dataGridConfig.filterAr != undefined) {
          this.dataGridConfig.filterAr = this.dataGridConfig.filterAr ? this.dataGridConfig.filterAr : filterSavedObj["filterAr"];
        } else {
          if (filterSavedObj && filterSavedObj["filterAr"] != undefined && this.dataGridConfig && this.dataGridConfig.filterAr == undefined) {
            this.dataGridConfig.filterAr = filterSavedObj["filterAr"];
          }
        }

        delete this._currentData.loadSavedFilter;
        /********TODO PRININFO IMPLEMENT ON PRINT FROM SAVED FILTER *******/
        //this.storageService.removeSesssionData(filterSaveKey+"_"+this._currentData.resouceDef.resource);
      }
    } catch (error) {

    }

  }


  getFilterLabel() {
    console.log("========getFilterLabel===============");
    if (this.persistGrid()) {
      try {
        var snapshot = this.aRoute.snapshot;
        var filterSaveKey = "f__k";
        var params = { ...snapshot.queryParams };
        if (params[filterSaveKey] != undefined && params[filterSaveKey]) {
          var filterObj = this.storageService.getSessionStorageDataSync(filterSaveKey + "_ts" + this.dataGridConfig.resource);
          if (filterObj) {
            if (filterObj["key"] != undefined && filterObj["key"] == params[filterSaveKey]) {
              return filterObj;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    } else {
      return false;
    }

  }

  persistGrid() {
    if (this._currentData.origArhiveConfig != undefined) {
      return false;
    }
    if (this._currentData && this._currentData["archiveConfig"] != undefined && this._currentData["archiveConfig"]["applied"] != undefined && this._currentData["archiveConfig"]["applied"]) {
      return false;
    }
    // return (this.constructor.name.toLowerCase() == "trackordercomponent");
    return true;
  }

  hasData(search?) {
    this._currentData.loadSavedFilter = true;
    let searchStr = {};
    this.updateCurrentDataFromSavedFilter();

    this._currentData.datasource = JSON.parse(JSON.stringify(this._currentData.resouceDef.list.APIresource.datasource));

    // this._currentData.searchKey = search;
    // for setting this.data if empty for building dynamic args / filters then fetch from sessionStorage
    if (!this.data && sessionStorage?.getItem('currentData')) {
      this.data = JSON.parse(sessionStorage.getItem('currentData'));
    }
    var data = {
      filter: this._currentData.datasource.filter != undefined ? this.baseService.buildDyanamicStr(this._currentData.datasource.filter, { data: this.data }) : '',
      args: this._currentData.datasource.args != undefined ? this.baseService.buildDyanamicStr(this._currentData.datasource.args, { data: this.data }) : '',
      page_size: this.limit,
      page_no: this.page,
    }
    if (this.appService.getAccountConfig() && this.appService.getAccountConfig().regex_search != undefined && this.appService.getAccountConfig().regex_search == true) {
      //do nothing
    } else {
      if (search != undefined && search.searchObj != undefined && search.searchObj.eq_search != undefined) {
        data['eq_search'] = 'y';
      }

      if (search == undefined && this._currentData.searchKey != undefined && this._currentData.searchKey && this._currentData.searchKey['eq_search']) {
        data['eq_search'] = 'y';
        // delete this._currentData.searchKey;
      }
      if (search != undefined && search.eq_search != undefined && this._currentData.searchKey != undefined && this._currentData.searchKey && this._currentData.searchKey['eq_search']) {
        data['eq_search'] = 'y';
      }
    }


    if (this._currentData.resouceDef.config.projection_keys) {
      data['projectionKeys'] = this.baseService.getProjectionKeys(this._currentData.resouceDef.list.fields, (this._currentData.resouceDef.list.projectionKeys ? this._currentData.resouceDef.list.projectionKeys : []))
    }
    if (this.applyFilter)
      data['filter'] = this.filterValue;
    if (this._currentData.searchKey != undefined && this._currentData.searchKey) {
      data['search'] = this._currentData.searchKey.value;
      data['search_columns'] = this._currentData.searchKey.key ? this._currentData.searchKey.key : '';
      // setting pageNo to zero while applying complexSearch first time
      if (this._currentData.searchKey.setPageNo) {
        data['page_no'] = 0;
        this._currentData.searchKey.setPageNo = false;
      } else {
        data['page_no'] = this.page;
      }
    }
    if (this.sortData != undefined) {
      data['order_by'] = this.sortData
    }
    if (this.dataGridConfig.noCount) {
      data.args += data.args.length == 0 ? "noCount:1" : ",noCount:1"
    }
    this.callApi(data);
  }

  callApi(data) {

    //setting code for persistance 
    try {
      console.log("Call api for track order");
      if (this._currentData.saveFilterKey != undefined && this.persistGrid()) {
        delete this._currentData.saveFilterKey;
        this.saveFilterObj({ gridData: data }, (responseConfig) => {
          var queryObj = {};
          queryObj[responseConfig["filterSaveKey"]] = responseConfig["filterKey"];
          if (data['page_no'] != undefined && data['page_no'] != undefined) {
            queryObj['p__no'] = data['page_no'];
          }
          if (data['page_size'] != undefined && data['page_size'] != undefined) {
            queryObj['p__size'] = data['page_size'];
          }
          var url = this.route.createUrlTree([], { relativeTo: this.aRoute, queryParams: queryObj, queryParamsHandling: 'merge' }).toString()
          this.locationCommon.replaceState(url);

          //this.router.onSameUrlNavigation = 'ignore';
          this.route.navigate(['.'], { relativeTo: this.aRoute, queryParams: queryObj, replaceUrl: true, queryParamsHandling: 'merge' });//maintain history so that user could go back (uncommenting because router params was not updating)
        });
      }

    } catch (e) {
      console.log(e);
    }
    this.loader.showSpinner();
    if(data != undefined && this.filters != undefined){
          data.filter += `,${this.filters}`;
        }
    this.baseService.getWithPage(data, this._currentData.datasource.resource, this._currentData.datasource.application, this._currentData.datasource.query_id).subscribe(data => {
      this.loader.hideSpinner();
      if (data && data.resource != undefined && data.resource) {
        this.GridData = {}
        this.GridData['resource'] = data.resource;
        this.GridData['count'] = data.count;
      }
    })
  }

  saveFilterObj(config, callback) {
    var filterSaveKey = "f__k";
    var gridData;
    var filterKey = this.baseService.generateID(5);
    var filterObj = { key: filterKey };
    var savedObj = this.getFilterLabel();

    if (savedObj && savedObj["key"] != undefined) {
      filterObj["key"] = savedObj["key"]; //we found already saved filter whose key is present in url bar
    }

    if (config["gridData"] != undefined) {
      gridData = config["gridData"];
      if (gridData['filter'] != undefined && gridData['filter']) {

        if (gridData['filter'] != undefined) {
          filterObj["filter"] = gridData['filter'];
        }

        if (this._currentData.filterPrintInfo != undefined) {
          filterObj["filterLabel"] = this._currentData.filterPrintInfo;
        }

      }

      if (gridData && gridData["search_columns"] != undefined) {
        filterObj["search_columns"] = gridData["search_columns"];
      }

      if (gridData && gridData["search"] != undefined) {
        filterObj["search"] = gridData["search"];
        filterObj["f__search"] = gridData["search"];
      }
      if (gridData && gridData["searchLabel"] != undefined) {
        filterObj["searchLabel"] = gridData["searchLabel"];
        filterObj["f__searchLabel"] = gridData["searchLabel"];
      } else if (gridData && this.dataGridConfig && this.dataGridConfig.searchLabel != undefined && this.dataGridConfig.searchLabel) {
        filterObj["searchLabel"] = this.dataGridConfig.searchLabel;
        filterObj["f__searchLabel"] = this.dataGridConfig.searchLabel;
      }

      if (gridData && gridData["searchColumns"] != undefined) {
        filterObj["searchColumns"] = gridData["searchColumns"];
        filterObj["f__searchColumns"] = gridData["searchColumns"];
      }
      if (gridData && gridData["noRule"] != undefined) {
        filterObj["noRule"] = gridData["noRule"];
      }

      if (gridData && gridData["eq_search"] != undefined) {
        filterObj["eq_search"] = gridData["eq_search"];
        filterObj["f__eq_search"] = gridData["eq_search"];
      }

      if (gridData && this.dataGridConfig && this.dataGridConfig.filterConfig != undefined && this.dataGridConfig.filterConfig["FilterName"] != undefined) {
        filterObj["filterName"] = this.dataGridConfig.filterConfig["FilterName"];
        filterObj["FilterName"] = this.dataGridConfig.filterConfig["FilterName"];
      }
      if (gridData && this.dataGridConfig && this.dataGridConfig.filterAr != undefined) {
        filterObj["filterAr"] = this.dataGridConfig.filterAr;
      }
      this.storageService.setSessionStorageData(filterSaveKey + "_ts" + this.dataGridConfig.resource, filterObj, () => {
        callback({ filterSaveKey: filterSaveKey, filterKey: filterObj["key"] });
      });
    }

    return false;


  }

  getConfigValues(event) {
    if (event.filterPrintInfo != undefined && event.filterPrintInfo) {
      this._currentData.filterPrintInfo = event.filterPrintInfo;
      this._currentData.saveFilterKey = true;
    } else if (event.configureGrid != undefined) {
      this.configUIEngine(event.configureGrid);
    }
  }


  switchView(res) {
    var snapshot = this.aRoute.snapshot;
    var params = { ...snapshot.queryParams };
    var tab_key = 'layout';
    params[tab_key] = res;
    this._currentData.dataGridConfig = { ...this.dataGridConfig, ...this._currentData.gridData };
    this._currentData.dataGridConfig.limit = this._currentData.gridData.page_size;
    console.log("Grid Table ", this._currentData.dataGridConfig);
    if (res == 'table') {
      this._currentData['activeField'] = 'table';
       this.dataGridConfig.tile = false
      this.dataGridConfig.activeField = this._currentData['activeField']
      if (this._currentData.activeField) {
        this._currentData.showView = false;
        setTimeout(() => {
          this._currentData.showView = true;
        })
      }
    }
    else if (res == 'tile') {
      this._currentData['activeField'] = 'tile';
      this.dataGridConfig.tile = true
      this.dataGridConfig.activeField = this._currentData['activeField']
      if (this._currentData.activeField) {
        this._currentData.showView = false;
        setTimeout(() => {
          this._currentData.showView = true;
        })
      }
      // this.bindGrid();
    }

    //  this.savePreference();
  }



  redirect(action: any, btnAction) {
    const actionType = btnAction ? btnAction : action?.actionType;
    const actionData = btnAction ? action : action?.data;

    if (actionType && actionType.action == 'print') {
      if (Array.isArray(actionData) && actionType.file_data?.cumulativeInfo) {
        const bulkPrintAction = JSON.parse(JSON.stringify(actionType));
        const cumulativeInfo = this.baseService.createCumilativeObj({ action: bulkPrintAction, items: actionData });
        bulkPrintAction.file_data.cumulativeInfo = btoa(JSON.stringify(cumulativeInfo));
        if (bulkPrintAction.file_data.filterPrintInfo && typeof bulkPrintAction.file_data.filterPrintInfo !== 'string') {
          bulkPrintAction.file_data.filterPrintInfo = btoa(JSON.stringify(bulkPrintAction.file_data.filterPrintInfo));
        }
        this.handleFile(bulkPrintAction, { data: {} });
        return;
      }
      this.handleFile(actionType, actionData);
    } else if (action && action.actionType && action.actionType.action == 'api_call') {
      this.dataGridConfig['noCount'] = false;
      this.callDatasource(action.actionType);
      this.hasData();
    } else if (action && action.actionType && action.actionType.action == 'refresh') {
      this.dataGridConfig['noCount'] = false;
      this.hasData();
    } else if (action && action?.actionType && action?.actionType?.action == 'savedata') {
      //initiatiing capability decorartor
      if (this._currentData && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.capabilityDecorater) {
        this._currentData.decorator = this.baseService.initDecorator(this._currentData.resouceDef.config.decorator, this.route, this.injector);
        this._currentData.decorator.capabilityClick(action, (val) => {
          if (val) {
            return;
          }
        });
      }
    }
    else if (action && action.actionType && action.actionType.action == 'redirect_withKey') {
      // http://localhost:4599/diagnostic/OrderNo%2520Dc-4541/specimen_collection/collectsample?returnUrl=%2Fdiagnostic%2Fspecimen_format%2Flist%3Ftab_0%3Dcollection%26p__no%3D0&key=OrderNo%20Dc-4541&query_params=orderId:OrderNo%20Dc-4541,serviceType_code:pathology
      this.route.navigate(["/" + action.actionType.application + "/" + action.data[action.actionType.redirectkey] + '/' + action.actionType.type + '/' + action.actionType.redirectRoute], { queryParams: { returnUrl: this.route.url, key: action.data[action.actionType.key], query_params: this.baseService.buildDyanamicStr(action.actionType.query_params, { data: action.data }) } })
      sessionStorage.setItem("currentData", JSON.stringify(action.data));
    } else if (action && action.actionType && action.actionType.action == 'view_file') {
      if (action.actionType?.decorator) {
        this._currentData.decorator = this.baseService.initDecorator(action.actionType.decorator, this.route, this.injector);
        this._currentData.decorator.capabilityClick(action, (val) => {
          if (val) {
            this.handleFile(action.actionType, action.data);
          } else {
            return;
          }
        });
      } else {
        this.handleFile(action.actionType, action.data);
      }
    }
    else if (action && action.actionType && action.actionType?.action == 'print') {
      this.handleFile(action.actionType, action.data);
    } else if(action && action.actionType && action.actionType?.action == 'custom' && action.actionType?.route_path && action.actionType?.route_path != undefined){
      this.baseService.redirectToOtherPage(action.actionType.route_path, action.data);
      sessionStorage.setItem("currentData", JSON.stringify(action.data));
    } else {
      this.route.navigate(["/" + action.actionType.application + "/" + action.actionType.type], { queryParams: { returnUrl: this.route.url, key: action.data[action.actionType.key] } })
      sessionStorage.setItem("currentData", JSON.stringify(action.data));
    }
  }

  handleFile(action, obj, callback = null) {
    this.printService.handlePrint(action, obj, callback);
  }

  onBulkActionClicked(action_obj) {
    if (typeof action_obj.action == "object" && action_obj.action.action != undefined && ['print', 'download', 'view_file'].indexOf(action_obj.action.action) > -1) {
      if (action_obj.action.file_data != undefined && action_obj.action.file_data.cumulativeInfo != undefined && action_obj.items != undefined && action_obj.items.length > 0) {
        // if (this.appService.getUniversalConfig('multi_care_type')) {
        //   this.addFilterDownload() // this line is added to add filter in resource if present in resource
        // }
        let cumulativeInfoObject = JSON.parse(JSON.stringify(action_obj.action.file_data.cumulativeInfo));
        let cumulativeInfo = this.baseService.createCumilativeObj(action_obj);
        action_obj.action.file_data.cumulativeInfo = btoa(JSON.stringify(cumulativeInfo));
        if (action_obj.action.file_data.filterPrintInfo != undefined && action_obj.action.file_data.filterPrintInfo) {
          action_obj.action.file_data.filterPrintInfo = btoa(JSON.stringify(action_obj.action.file_data.filterPrintInfo));
        }
        this.handleFile(action_obj.action, { data: {} });
      }
    }
  }

  sortChanges(event: any) {
    if (event == undefined)
      this.sortData = undefined
    else {
      if (event && event.key && event.value) {
        this.sortData = event.key + " " + event.value;

        // fixed for showing UI arrow sorting in desc order 
        this.dataGridConfig.FrontDefaultSort.type == -1 ? this.dataGridConfig.FrontDefaultSort.type = 0 : this.dataGridConfig.FrontDefaultSort.type;
      }
      // if sorting is cleared then default APIresource sort will apply
      else if (event && event.clear) {  
        this.sortData = this._currentData.resouceDef.list.APIresource.datasource.sortData;
        
        // for removing the sort popup
        delete this.dataGridConfig.FrontDefaultSort;
      }
    }
    this.hasData();
  }

  bindDataToGrid(event: any) {
    this._currentData.saveFilterKey = true;
    this.loader.showSpinner();
    if (event != undefined)
      this.applyFilter = true;
    else
      this.applyFilter = false;
    this.filterValue = this.filterService.removeDuplicateKeysFromString({ "filter": event });

    if (!event) {
      this.dataGridConfig['resetFilter_ts'] = true;
      // this.storageService.removeSesssionData('f__k' +  "_ts" + this.dataGridConfig.resource);
    }

    if (this._currentData.searchKey != undefined) {
      this.hasData(this._currentData.searchKey);
    } else {
      this.hasData();
    }
  }

  filterClick(event) {
    if (!event && this.dataGridConfig['f__search_columns'] != undefined && this.dataGridConfig['f__search'] != undefined) {
      delete this.dataGridConfig['f__search_columns'];
      delete this.dataGridConfig['f__search'];
      delete this.dataGridConfig['f__searchColumns'];
      delete this.dataGridConfig['f__searchLabel'];
    }

    if (!event) {
      this.dataGridConfig['resetFilter_ts'] = true;

      // this.storageService.removeSesssionData('f__k' +  "_ts" + this.dataGridConfig.resource);
    }

    if (event != undefined) {
      this.dataGridConfig['compex_search_ts'] = true;
      this.dataGridConfig['searchLabel'] = (event && event.label) ? event.label : '';
    }

    this.page = 0;
    this.updatePageInUrl(this.page);
    this._currentData.saveFilterKey = true;
    this._currentData.searchKey = event;
    //event['setPageNo'] = true;
    this.hasData(event);
  }

  public onLimit(event) {
    this.dataGridConfig['resetFilter_ts'] = true;
    this.limit = event.target.value;
    this.page = 0;
    this.updatePageInUrl(this.page);
    this.hasData();
  }

  onPageChanged(event: any) {
    this.dataGridConfig['resetFilter_ts'] = true;
    this._currentData.saveFilterKey = true;
    this.page = event - 1;
    this.updatePageInUrl(this.page);
    this.hasData();
  }

  updatePageInUrl(pageNo, force = false) {
    if (this.persistGrid() || force) {
      this.dataGridConfig['page_no'] = this.page;
      var snapshot = this.aRoute.snapshot;
      var params = { ...snapshot.queryParams };
      params["p__no"] = pageNo;

      var url = this.route.createUrlTree([], { relativeTo: this.aRoute, queryParams: params, queryParamsHandling: '' }).toString()
      this.locationCommon.replaceState(url);

      //this.router.onSameUrlNavigation = 'ignore';
      this.route.navigate(['.'], { relativeTo: this.aRoute, queryParams: params, replaceUrl: true, queryParamsHandling: '' });//maintain history so that user could go back  //(uncommenting because router params was not updating)

    }
  }

  checkCancelStatus() {
    return this._currentData.resouceDef != undefined ? (this._currentData.resouceDef.show_cancelled != undefined ? this._currentData.resouceDef.show_cancelled : true) : '';
  }

  callDatasource(data) {
    this.loader.showSpinner();
    data.args = data.args ? data.args : '';
    data.filter = data.filter ? data.filter : '';
    this.baseService.get(data.action_name, data.args, data.resource, data.application, data.filter).subscribe(res => {
      if (res.errCode != undefined && res.errCode == 0 && res.resource.length > 0) {
        console.log("If :: " + res.message);
        this.formService.alerts.success(res.message);
      } else {
        console.log("Else :: " + res.message);
        this.formService.alerts.error(res.message);
      }
      this.loader.hideSpinner();
    })
  }

  configUIEngine(config) {
    var obj: any = {};
    obj = { ...obj, ...config };
    obj["key"] = this.getConfigurationKey(config);
    obj["resource_name"] = this.input;
    if (config.context == 'grid') {
      obj["resource_name"] = this._currentData.resouceDef.resource;
    }
    this.preferenceService.openConfigurePopup(obj, (response) => {
      if (response.result != undefined) {
        this.preferenceService.saveConfigurationData(obj, response.result, (result) => {
          console.log(result);
        });
      }
    });
  }

  getConfigurationKey(config) {
    var resourceName = this.input;
    if (config.context == 'grid') {
      resourceName = this._currentData.resouceDef.resource;
    }
    return this.preferenceService.getConfigurationKey(resourceName);
  }
}
